import { Icon } from '@stenajs-webui/elements';
import type { SpecialBookingIconMeta } from '../use-cases/manage/grid/utils/bookingSpecialProperties';

export const IconWithDescription = ({ iconInfo }: { iconInfo: SpecialBookingIconMeta | null }) => {
  if (!iconInfo) {
    return null;
  }

  return (
    <div title={iconInfo.description}>
      <Icon icon={iconInfo.icon} size={16} />
    </div>
  );
};
